export default __webpack_public_path__ + "static/media/ic-chapter-test.c3c34367.svg";